import Header1 from "../Header_1/Header1"
import Header2 from "../Header_2/Header2"
import "./header.css"

function Headers(){
    return(
        <>
        <div className="sticky_headers">
        <Header1/>
        <Header2/>
        </div>
        </>
    )
}
export default Headers